import ContentType from './ContentType';
import ContentTypes from './ContentTypes';

export const ComponentRefNames = {
    MapMarkers: 'MapMarkers'
    /*PartnerLogos: 'PartnerLogos'*/
};

export default class ComponentRefContentType extends ContentType {
    constructor(props) {
        super({
            type: ContentTypes.ComponentRef,
            props
        });

        this.name = ComponentRefNames.MapMarkers;
    }
}
